// extracted by mini-css-extract-plugin
export var subtitle = "_a0-2";
export var title = "_a0-0";
export var titleNoWrap = "_a0-1";